<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content" />

		<contentblocks :items="page.contentblocks" />
		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:items="page.frequentlyAskedQuestion.faqitems"
			:header="page.frequentlyAskedQuestion.header"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
let retryTimer;
let hiringAssistant;
let buttonWasVisible = false;

await fetchPage();

const openHiringAssistant = () => {
	const assistant = window.hiringAssistant;

	if (!assistant?.isInitialized?.()) {
		retryTimer = window.setTimeout(openHiringAssistant, 250);

		return;
	}

	hiringAssistant = assistant;
	buttonWasVisible = assistant.getButtonState().isVisible;
	assistant.showButton();

	if (!assistant.isOpen()) {
		assistant.open();
	}
};

onMounted(openHiringAssistant);

onBeforeUnmount(() => {
	window.clearTimeout(retryTimer);
	hiringAssistant?.close();

	if (!buttonWasVisible) {
		hiringAssistant?.hideButton();
	}
});

useHead({
	bodyAttrs: {
		class: 'jobs',
	},
});
</script>

<style lang="scss" scoped>
.gallery {
	padding-top: 0;
	padding-bottom: 100px;
	background-color: $primary-background-color;
}
</style>
